










import Vue from 'vue';
import PipelineMenu from '@/components/PipelineMenu/PipelineMenu.vue';
import i18n from '@/i18n';
import prouniPipeline from '@/pipeline/prouni';
import prouniSteps from '@/pipeline/prouni/steps';

interface PipelineItem {
  title: string;
  steps: string[];
  childrenActive: boolean;
  children: { title: string; steps: string[] }[];
}

const MENU_STEPS: { key: string; step: string }[] = [
  { key: 'personalData', step: prouniSteps.personalData },
  { key: 'personalDocuments', step: prouniSteps.personalDocuments },
  { key: 'residence', step: prouniSteps.residence },
  { key: 'familyIncome', step: prouniSteps.familyIncome },
  { key: 'education', step: prouniSteps.education },
  { key: 'acceptance', step: prouniSteps.acceptance },
];

export default Vue.extend({
  name: 'ProuniPipelineMenu',
  components: { PipelineMenu },
  data() {
    return {
      pipelineItems: [] as PipelineItem[],
      currentStep: '',
      stepHistory: [] as string[],
    };
  },
  mounted() {
    const forceTrigger = prouniPipeline.initialized;
    prouniPipeline.addTransitionListener(this.onPipelineUpdate, forceTrigger);
  },
  beforeDestroy() {
    prouniPipeline.removeTransitionListener(this.onPipelineUpdate);
  },
  methods: {
    goToStep(step: string) {
      if (prouniPipeline.initialized) prouniPipeline.goTo(step);
    },
    onPipelineUpdate() {
      if (!prouniPipeline.initialized) return;

      this.pipelineItems = MENU_STEPS.map(({ key, step }) => ({
        title: i18n.t(`prouni.pipelineMenu.${key}`) as string,
        childrenActive: false,
        steps: [step],
        children: [],
      }));
      this.currentStep = prouniPipeline.currentStep;
      this.stepHistory = (prouniPipeline.state.context as { history?: string[] }).history || [];
    },
  },
});
